<template>
  <table class="table is-hoverable">
  <thead>
    <tr>
      <th class="type" nowrap>
        <!-- role=button prevents touch-to-search on android chrome -->
        <a role="button" @click="toggleSort('type')">Type
          <span v-if="sortField === 'type'">
            <font-awesome-icon :icon="sortIcon" />
          </span>
        </a>
      </th>
      <th nowrap class="is-hidden-mobile">
        <a role="button" @click="toggleSort('access')">Access
          <span v-if="sortField === 'access'">
            <font-awesome-icon :icon="sortIcon" />
          </span>
        </a>
      </th>
      <th nowrap>
        <a role="button" @click="toggleSort('name')">Name
          <span v-if="sortField === 'name'">
            <font-awesome-icon :icon="sortIcon" />
          </span>
        </a>
      </th>
      <th class="is-hidden-mobile">
        Description
      </th>
      <th class="is-hidden-mobile">
        Categories
      </th>
      <th nowrap class="is-hidden-mobile">
        <a role="button" @click="toggleSort('addrSortValue')">Address
          <span v-if="sortField === 'addrSortValue'">
            <font-awesome-icon :icon="sortIcon" />
          </span>
        </a>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="fi in foodItems" :key="fi.id">
      <td>
        <span class="icon is-size-4-mobile">
          <b-icon size="is-small" :icon="typeIcon(fi.type)" />
        </span>
        <div class="is-hidden-tablet">
          <span class="icon">
            <b-icon size="is-small" :icon="accessIcon(fi.access)" />
          </span>
        </div>
      </td>
      <td nowrap class="is-hidden-mobile">
        <span class="icon">
          <b-icon :icon="accessIcon(fi.access)" />
        </span>
      </td>
      <td>
        <a role="button" class="is-inverted is-size-4-mobile" @click="routeFoodItem(fi)">{{fi.name}}</a>
        <a v-if="fi.link" :href="fi.link" target="_blank">
          <span class="icon">
            <font-awesome-icon v-if="youTubeLink(fi.link)" :icon="['fab', 'youtube']" />
            <font-awesome-icon v-else icon="external-link-alt" />
          </span>
        </a>
        <!-- Mobile only -->
        <div class="is-inline-block-mobile is-hidden-tablet is-size-4-mobile">
          <a v-if="fi.description" @click="descClicked(fi)">
            <span class="icon">
              <font-awesome-icon icon="info-circle" />
            </span>
          </a>
        </div>
        <div class="is-block-mobile is-hidden-tablet">
          <div class="mobile-name-sub-line">
            <div v-if="fi.categories" class="tags is-small">
              <span v-for="c in fi.categories" :key="c" class="tag is-info">{{c}}</span>
            </div>
          </div>
          <div class="mobile-name-sub-line">
            <a v-if="fi.address && fi.address.city" :href="addrHref(fi)" target="_blank">{{fi.address.city}}</a>
            <template v-else>{{addrString(fi.address)}}</template>
          </div>
        </div>
        <!-- End mobile only -->
      </td>
      <td class="is-hidden-mobile">
        <a v-if="fi.description && fi.description.length > maxDescChars" @click="descClicked(fi)">{{truncateDesc(fi.description)}}</a>
        <template v-else>{{fi.description}}</template>
      </td>
      <td class="is-hidden-mobile">
        <div v-if="fi.categories" class="tags">
          <span v-for="c in fi.categories" :key="c" class="tag is-light">{{c}}</span>
        </div>
      </td>
      <td class="is-hidden-mobile">
        <a v-if="fi.address && fi.address.city" :href="addrHref(fi)" target="_blank">{{fi.address.city}}</a>
        <template v-else>{{addrString(fi.address)}}</template>
      </td>
    </tr>
  </tbody>
</table>

</template>

<script>
import BrowseMixin from './BrowseMixin';

export default {
  name: 'browse-table',
  mixins: [BrowseMixin],
};
</script>

<style lang="sass" scoped>

th.type
  width: 5rem

.mobile-name-sub-line
  display: block
  padding-left: 0.5rem
  padding-top: 0.5rem

</style>



// WEBPACK FOOTER //
// src/components/browse/BrowseTable.vue